import { Spin } from 'antd';

import './index.css';
import { CircularProgress, styled } from '@mui/material';

const StyledCircularProgress = styled(CircularProgress)(() => ({
  color: 'black',
}));

type Props = { isLp?: boolean };

const ContentLoader: React.FC<Props> = ({ isLp }) => {
  return (
    <div className="content-loader">
      {isLp ? <StyledCircularProgress enableTrackSlot /> : <Spin />}
    </div>
  );
};

export default ContentLoader;
